import Icon from "@/components/Icon";
import { WithClassName } from "@/types/base";
import { Box, Center, chakra, Flex, useBoolean } from "@chakra-ui/react";
import { observer } from "mobx-react-lite";
import React, { useEffect } from "react";

import { ReactComponent as AddSvg } from "@/assets/icons/pure_add.svg";
import { albumStore } from "@/modules/album/store";
import { AlbumItem } from "./AlbumItem";
import { CreatorAlbumDetail } from "./AlbumDetail";
import { CreateAlbumModal } from "@/modules/album/components/CreateModal";
import getScrollBarProps from "@/styles/scrollBarProps";
import { useTranslate } from "@/utils/lang";
import { AlbumWords } from "@/utils/lang/album";
import { useAlbumListMenuScroll } from "@/modules/album/hook/useAlbumListMenuScroll";

const scrollProps = getScrollBarProps({ autoMargin: false });
const EditorAlbum: React.FC<WithClassName> = ({ className }) => {
  const { translate } = useTranslate();
  const { fetchAlbums, albumList, curSelectAlbum, setCurSelectAlbum } = albumStore;
  const [open, openOp] = useBoolean(false);
  // 加载更多
  const { scrollContainerRef } = useAlbumListMenuScroll({
    triggerOnNoScroll: albumStore.albumManager.hasMore,
  });

  useEffect(() => {
    fetchAlbums();
  }, []);

  return (
    <Flex pos="relative" className={className} w="100%" flex={1}>
      <Center
        pos="absolute"
        right="16px"
        top="-54px"
        color="text.disabled"
        fontSize="12px"
        cursor="pointer"
        onClick={openOp.on}
      >
        <Icon svg={AddSvg} squared={false} />
        {translate(AlbumWords.newAlbum)}
      </Center>
      <Box px="16px" w="100%" h="100%" {...scrollProps} ref={scrollContainerRef as any}>
        {albumList.map((album) => {
          return (
            <AlbumItem
              mb="16px"
              key={album.id}
              data={album}
              onClick={() => setCurSelectAlbum(album)}
            />
          );
        })}
      </Box>
      {curSelectAlbum ? (
        <CreatorAlbumDetail key={curSelectAlbum.id} album={curSelectAlbum} pos="absolute" />
      ) : null}
      <CreateAlbumModal isOpen={open} onClose={openOp.off} />
    </Flex>
  );
};

export const AlbumPanel = chakra(observer(EditorAlbum));
